// extracted by mini-css-extract-plugin
export var actionButton = "_pz-0";
export var actionMenuContainer = "_pz-i";
export var bubble = "_pz-2";
export var bubbleActionMenu = "_pz-j";
export var bubbleContext = "_pz-6";
export var bubbleItems = "_pz-7";
export var customer = "_pz-3";
export var divider = "_pz-8";
export var fileList = "_pz-9";
export var hiddenComment = "_pz-o";
export var infoAbove = "_pz-a";
export var internal = "_pz-4";
export var lightActionButton = "_pz-1";
export var link = "_pz-b";
export var merchant = "_pz-5";
export var message = "_pz-c";
export var profilePicture = "_pz-e";
export var quillToolbarContainer = "_pz-f";
export var senderDate = "_pz-g";
export var senderDateCustomer = "_pz-h";
export var senderName = "_pz-d";
export var time = "_pz-k";
export var uploadedImage = "_pz-l";
export var username = "_pz-m";
export var xsmall = "_pz-n";